var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"md":"4","sm":"6","xs":"12"}},[_c('v-card',{staticClass:"helpcard",attrs:{"outlined":""}},[_c('v-card-text',[_c('h2',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }